import { Drawer } from "../modules/common/other/Drawer";
import { Booking } from "../modules/common/other/Booking";
import { LifetimeAnnuity } from "../modules/common/info-articles/LifetimeAnnuity"
import { FixedTermAnnuity } from "../modules/common/info-articles/FixedTermAnnuity";
import { FlexibleAccessDrawdown } from "../modules/common/info-articles/FlexibleAccessDrawdown";
import { QuoteError } from "../modules/common/info-articles/QuoteError";

export default function AppDrawers() {
  return (
    <>
      <Drawer
        id="whatIsALifeTimeAnnuity"
        title={
          <h2 className="card-title fw-bold text-gray-600 col-10">
            What is a Lifetime Annuity?
          </h2>
        }
        content={<LifetimeAnnuity />}
      />
      <Drawer
        id="whatIsAFixedTermAnnuity"
        title={
          <h2 className="card-title fw-bold text-gray-600 col-10">
            What is a Fixed Term Annuity?
          </h2>
        }
        content={<FixedTermAnnuity />}
      />
      <Drawer
        id="whatIsFlexibleAccessDrawdown"
        title={
          <h2 className="card-title fw-bold text-gray-600 col-10">
            What is Flexi-Access Drawdown?
          </h2>
        }
        content={<FlexibleAccessDrawdown />}
      />
      <Drawer
        id="booking"
        title={
          <h2 className="card-title fw-bold text-gray-600 col-10">
            Book an appointment
          </h2>
        }
        content={<Booking />}
      />
      <Drawer
        id="quoteError"
        title={
          <h2 className="card-title fw-bold text-gray-600 col-10">
            Why couldn't we get all quotes?
          </h2>
        }
        content={<QuoteError />}
      />
    </>
  );
}
